import Vue from 'vue';
import moment from 'moment';

function init() {
  // 格式化UTC时间到本地时间
  Vue.filter('formatDate', (value) => {
    if (value) {
      const dataFormat = 'YYYY/MM/DD HH:mm:ss dddd';
      // moment.lang('zh-cn');
      moment.locale('zh-cn');
      return moment((String(value))).format(dataFormat);
    }
    return value;
  });
  Vue.filter('formatDateNormal', (value) => {
    if (value) {
      const dataFormat = 'YYYY-MM-DD HH:mm:ss';
      // moment.lang('zh-cn');
      moment.locale('zh-cn');
      return moment((String(value))).format(dataFormat);
    }
    return value;
  });
  Vue.filter('formatDateShort', (value) => {
    if (value) {
      const dataFormat = 'YYYY-MM-DD';
      // moment.lang('zh-cn');
      moment.locale('zh-cn');
      return moment((String(value))).format(dataFormat);
    }
    return value;
  });
  // 计算时间离当前时间的差值
  Vue.filter('fromNow', (value) => {
    if (value) {
      moment.locale('zh-cn');
      return moment((String(value))).fromNow();
    }
    return value;
  });
}

export default init;



// WEBPACK FOOTER //
// ./src/common/VueFilter.js